import type { Site } from '@/types/site';

export const sites: Site[] = [
  {
    id: 'huaxia-window',
    name: '华夏之窗',
    url: 'https://www.huaxiazhichuang.com',
    domain: 'huaxiazhichuang.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20web%20brand%20named%20Huaxia%20Window%20with%20abstract%20geometric%20doorway%20symbol%20in%20deep%20blue%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-huaxia-window&orientation=squarish',
    description: '面向全球华人的综合信息门户，聚合资讯、生活与服务栏目。',
    intro: '华夏之窗是面向全球华人用户的综合信息门户，以资讯聚合、生活服务与政务服务为主线，设有要闻、财经、文化、生活等多个频道。平台强调内容权威与来源可溯，帮助用户在一个入口内快速了解天下事。',
    categoryId: 'portal',
    region: '北京',
    scale: '顶级',
    tags: ['综合门户', '资讯聚合', '生活服务'],
    addedAt: '2026-08-12',
    rating: 4.8,
    visits: 2860000,
    featured: false,
  },
  {
    id: 'yuntu-nav',
    name: '云图导航',
    url: 'https://www.yuntu123.com',
    domain: 'yuntu123.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20web%20brand%20named%20Yuntu%20Nav%20with%20abstract%20layered%20compass%20symbol%20in%20deep%20blue%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-yuntu-nav&orientation=squarish',
    description: '轻量级网址导航与书签聚合工具，支持自定义快捷入口。',
    intro: '云图导航是一款轻量级网址导航工具，支持用户自定义常用网站快捷入口与分组书签，并提供丰富的公共站点分类。界面简洁、加载迅速，适合作为浏览器首页使用，帮助用户高效管理上网入口。',
    categoryId: 'portal',
    region: '上海',
    scale: '高',
    tags: ['网址导航', '书签', '快捷入口'],
    addedAt: '2026-09-03',
    rating: 4.6,
    visits: 1520000,
    featured: false,
  },
  {
    id: 'huizhi-net',
    name: '汇智网',
    url: 'https://www.huizhiwang.com',
    domain: 'huizhiwang.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20web%20brand%20named%20Huizhi%20Net%20with%20abstract%20intersecting%20nodes%20symbol%20in%20deep%20blue%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-huizhi-net&orientation=squarish',
    description: '知识与资讯聚合社区，汇聚行业洞察与专业内容。',
    intro: '汇智网是一个知识型资讯聚合社区，聚集了大量行业分析师、媒体人与专业创作者，提供行业洞察、研究报告与深度解读内容。平台注重内容的专业性与讨论质量，适合从业者长期关注与交流。',
    categoryId: 'portal',
    region: '广东',
    scale: '高',
    tags: ['知识社区', '行业洞察', '专业内容'],
    addedAt: '2026-07-21',
    rating: 4.5,
    visits: 980000,
    featured: false,
  },
  {
    id: 'huanqiu-times',
    name: '环球时讯',
    url: 'https://www.huanqiushixun.com',
    domain: 'huanqiushixun.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20news%20brand%20named%20Global%20Times%20Wire%20with%20abstract%20globe%20and%20orbit%20symbol%20in%20warm%20orange%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-huanqiu-times&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=modern%20editorial%20news%20website%20hero%20banner%20with%20abstract%20globe%20and%20world%20map%20lines%20in%20warm%20orange%20gradient%20over%20deep%20navy%20background%2C%20clean%20professional%20magazine%20style%2C%20no%20text&width=1200&height=675&seq=cover-huanqiu-times&orientation=landscape',
    description: '国际与国内新闻权威聚合，第一时间掌握全球动态。',
    intro: '环球时讯是一家以国际时讯与国内要闻为核心的权威新闻聚合平台，拥有覆盖全球的采编网络，提供实时快讯、深度报道与多媒体专题。平台以快速、准确、全面著称，是了解全球动态的重要窗口。',
    categoryId: 'news',
    region: '北京',
    scale: '顶级',
    tags: ['新闻', '国际时讯', '实时快讯'],
    addedAt: '2026-09-28',
    rating: 4.9,
    visits: 3620000,
    featured: true,
  },
  {
    id: 'meiri-caijing',
    name: '每日财经观察',
    url: 'https://www.meiricaijing.com',
    domain: 'meiricaijing.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20finance%20media%20named%20Daily%20Finance%20Observer%20with%20abstract%20rising%20bar%20chart%20symbol%20in%20warm%20orange%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-meiri-caijing&orientation=squarish',
    description: '专注财经领域的深度报道与市场观察媒体。',
    intro: '每日财经观察是一家专注宏观经济与资本市场的财经媒体，提供政策解读、公司调研与市场观察内容。团队由资深财经记者与分析师组成，报道以数据扎实、视角独到见长，深受投资人与企业管理者信赖。',
    categoryId: 'news',
    region: '北京',
    scale: '高',
    tags: ['财经', '深度报道', '市场观察'],
    addedAt: '2026-08-30',
    rating: 4.6,
    visits: 1760000,
    featured: false,
  },
  {
    id: 'shendu-report',
    name: '深度报道社',
    url: 'https://www.shendubaodao.com',
    domain: 'shendubaodao.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20news%20brand%20named%20Deep%20Report%20Society%20with%20abstract%20magnifier%20and%20document%20symbol%20in%20warm%20orange%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-shendu-report&orientation=squarish',
    description: '以调查报道与特稿著称的深度内容平台。',
    intro: '深度报道社是一家以调查性报道、长篇特稿和人物专访见长的深度内容平台。坚持实地采访与多方求证，产出了大量具有社会影响力的报道，适合关注公共议题与深度阅读的用户。',
    categoryId: 'news',
    region: '上海',
    scale: '中',
    tags: ['深度调查', '特稿', '人物'],
    addedAt: '2026-07-15',
    rating: 4.4,
    visits: 640000,
    featured: false,
  },
  {
    id: 'youxuan-mall',
    name: '优选商城',
    url: 'https://www.youxuanshop.com',
    domain: 'youxuanshop.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20ecommerce%20brand%20named%20Youxuan%20Mall%20with%20abstract%20shopping%20bag%20symbol%20in%20coral%20red%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-youxuan-mall&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=modern%20ecommerce%20website%20hero%20banner%20with%20abstract%20shopping%20bag%20and%20soft%20coral%20red%20gradient%20shapes%20on%20light%20cream%20background%2C%20clean%20minimal%20retail%20style%2C%20no%20text&width=1200&height=675&seq=cover-youxuan-mall&orientation=landscape',
    description: '品质商品优选平台，严选品牌好物与优质服务。',
    intro: '优选商城是一家主打品质与信任的综合电商平台，覆盖数码家电、家居生活、美妆个护等品类。平台以严格的商家准入与品控体系著称，提供正品保障、快速物流与无忧售后，为消费者打造安心的购物体验。',
    categoryId: 'ecommerce',
    region: '浙江',
    scale: '顶级',
    tags: ['购物', '品质优选', '正品保障'],
    addedAt: '2026-09-20',
    rating: 4.8,
    visits: 4180000,
    featured: true,
  },
  {
    id: 'huigou',
    name: '惠购网',
    url: 'https://www.huigou.com',
    domain: 'huigou.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20shopping%20brand%20named%20Huigou%20Deals%20with%20abstract%20price%20tag%20symbol%20in%20coral%20red%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-huigou&orientation=squarish',
    description: '优惠比价与团购采购平台，帮用户精打细算。',
    intro: '惠购网是一款以优惠比价、限时团购和企业采购为核心的购物平台，聚合各大电商的促销信息与成交价格，帮助用户快速对比并锁定最优方案。适合注重性价比的个人消费者与中小采购商。',
    categoryId: 'ecommerce',
    region: '广东',
    scale: '高',
    tags: ['比价', '优惠', '团购'],
    addedAt: '2026-08-08',
    rating: 4.5,
    visits: 1320000,
    featured: false,
  },
  {
    id: 'binfen-market',
    name: '缤纷集市',
    url: 'https://www.binfenjishi.com',
    domain: 'binfenjishi.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20marketplace%20named%20Binfen%20Market%20with%20abstract%20market%20stall%20symbol%20in%20coral%20red%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-binfen-market&orientation=squarish',
    description: '特色好物集市，汇聚独立商家与创意商品。',
    intro: '缤纷集市是一个面向独立商家与创意品牌的特色好物集市，主打手作、设计感与地域特产。平台鼓励小而美的商家直接触达消费者，为用户发现与众不同的商品提供入口。',
    categoryId: 'ecommerce',
    region: '江苏',
    scale: '中',
    tags: ['特色好物', '独立商家', '创意商品'],
    addedAt: '2026-06-30',
    rating: 4.3,
    visits: 720000,
    featured: false,
  },
  {
    id: 'geek-front',
    name: '极客前线',
    url: 'https://www.geekfront.com',
    domain: 'geekfront.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20tech%20media%20named%20Geek%20Front%20with%20abstract%20chip%20circuit%20symbol%20in%20teal%20green%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-geek-front&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=modern%20technology%20website%20hero%20banner%20with%20abstract%20circuit%20board%20lines%20and%20teal%20green%20glow%20over%20dark%20charcoal%20background%2C%20futuristic%20minimal%20style%2C%20no%20text&width=1200&height=675&seq=cover-geek-front&orientation=landscape',
    description: '前沿科技资讯与数码产品评测媒体。',
    intro: '极客前线是一家专注科技前沿与数码产品的专业媒体，内容涵盖人工智能、芯片、智能硬件与消费电子评测。团队坚持一手实测与硬核技术解读，是科技爱好者与从业者获取行业动态的重要渠道。',
    categoryId: 'tech',
    region: '北京',
    scale: '高',
    tags: ['科技', '数码评测', '人工智能'],
    addedAt: '2026-09-25',
    rating: 4.8,
    visits: 2240000,
    featured: true,
  },
  {
    id: 'digital-future',
    name: '数字未来',
    url: 'https://www.shuziweilai.com',
    domain: 'shuziweilai.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20tech%20brand%20named%20Digital%20Future%20with%20abstract%20network%20hexagon%20symbol%20in%20teal%20green%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-digital-future&orientation=squarish',
    description: '聚焦智能科技与产业数字化趋势的内容平台。',
    intro: '数字未来是一个聚焦智能化与产业数字化的科技内容平台，持续输出行业趋势、企业案例与技术方案解析。平台与多家研究机构合作，内容兼具前瞻性与落地参考价值，适合企业决策者与技术从业者阅读。',
    categoryId: 'tech',
    region: '深圳',
    scale: '高',
    tags: ['智能科技', '产业数字化', '趋势'],
    addedAt: '2026-08-18',
    rating: 4.6,
    visits: 1180000,
    featured: false,
  },
  {
    id: 'zhizao-lab',
    name: '智造研究所',
    url: 'https://www.zhizao-lab.com',
    domain: 'zhizao-lab.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20tech%20lab%20named%20Zhizao%20Lab%20with%20abstract%20gear%20cube%20symbol%20in%20teal%20green%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-zhizao-lab&orientation=squarish',
    description: '智能硬件与先进制造领域的技术研究社区。',
    intro: '智造研究所是一个面向智能硬件与先进制造的技术研究社区，提供产品拆解、方案评测与行业技术白皮书。社区聚集了大量工程师与创业者，是了解硬件创新与制造工艺的实用参考。',
    categoryId: 'tech',
    region: '浙江',
    scale: '中',
    tags: ['智能硬件', '制造', '技术研究'],
    addedAt: '2026-07-09',
    rating: 4.4,
    visits: 560000,
    featured: false,
  },
  {
    id: 'caifu-zhiku',
    name: '财富智库',
    url: 'https://www.caifuzhiku.com',
    domain: 'caifuzhiku.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20finance%20brand%20named%20Wealth%20Thinktank%20with%20abstract%20vault%20and%20coin%20symbol%20in%20emerald%20green%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-caifu-zhiku&orientation=squarish',
    description: '个人理财与企业金融研究的智库型平台。',
    intro: '财富智库是一个面向个人理财与企业金融决策的智库型平台，提供研究报告、资产配置工具与专业课程。内容以稳健、专业为导向，帮助用户建立长期的财富管理观念与实操能力。',
    categoryId: 'finance',
    region: '北京',
    scale: '高',
    tags: ['理财', '研究报告', '资产配置'],
    addedAt: '2026-09-11',
    rating: 4.7,
    visits: 1680000,
    featured: false,
  },
  {
    id: 'rongtong-finance',
    name: '融通财经',
    url: 'https://www.rongtong.com',
    domain: 'rongtong.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20finance%20data%20brand%20named%20Rongtong%20Finance%20with%20abstract%20candlestick%20chart%20symbol%20in%20emerald%20green%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-rongtong-finance&orientation=squarish',
    description: '实时行情与金融数据服务入口。',
    intro: '融通财经提供股票、基金、外汇等市场的实时行情与专业金融数据服务，支持自选股、资讯提醒与图表分析。数据覆盖全面、更新及时，是投资者日常跟踪市场的常用工具。',
    categoryId: 'finance',
    region: '上海',
    scale: '顶级',
    tags: ['行情', '金融数据', '股票'],
    addedAt: '2026-08-25',
    rating: 4.6,
    visits: 2540000,
    featured: false,
  },
  {
    id: 'guhai-compass',
    name: '股海罗盘',
    url: 'https://www.guhailuopan.com',
    domain: 'guhailuopan.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20investment%20brand%20named%20Stock%20Compass%20with%20abstract%20compass%20needle%20symbol%20in%20emerald%20green%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-guhai-compass&orientation=squarish',
    description: '投资分析与策略分享的财经社区。',
    intro: '股海罗盘是一个投资分析与策略分享的财经社区，聚集了众多投资研究者与实战用户，提供市场复盘、策略研讨与风险提示内容。平台鼓励理性交流，适合希望系统提升投资认知的用户。',
    categoryId: 'finance',
    region: '深圳',
    scale: '中',
    tags: ['投资分析', '策略', '财经社区'],
    addedAt: '2026-07-02',
    rating: 4.3,
    visits: 480000,
    featured: false,
  },
  {
    id: 'xueeryou',
    name: '学而优在线',
    url: 'https://www.xueeryou.com',
    domain: 'xueeryou.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20education%20brand%20named%20Xueeryou%20Online%20with%20abstract%20open%20book%20symbol%20in%20amber%20gold%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-xueeryou&orientation=squarish',
    description: '覆盖多学科的在线课程与考试辅导平台。',
    intro: '学而优在线是一个覆盖K12、语言、职业考证等多学科的在线学习平台，提供系统课程、直播课堂与配套题库。平台师资公开透明、课程体系完整，适合有系统学习与备考需求的用户。',
    categoryId: 'edu',
    region: '北京',
    scale: '高',
    tags: ['在线课程', '考试辅导', '系统学习'],
    addedAt: '2026-09-16',
    rating: 4.7,
    visits: 1860000,
    featured: false,
  },
  {
    id: 'zhixing-class',
    name: '知行课堂',
    url: 'https://www.zhixingkt.com',
    domain: 'zhixingkt.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20learning%20brand%20named%20Zhixing%20Class%20with%20abstract%20graduation%20cap%20symbol%20in%20amber%20gold%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-zhixing-class&orientation=squarish',
    description: '兴趣素养与素质教育的精品课程社区。',
    intro: '知行课堂是一个专注兴趣素养与素质教育的精品课程社区，涵盖艺术、编程、演讲与生活美学等方向。课程以短小精悍与实践导向为特色，帮助用户利用碎片时间拓展技能边界。',
    categoryId: 'edu',
    region: '上海',
    scale: '中',
    tags: ['素质教育', '兴趣课程', '技能拓展'],
    addedAt: '2026-08-05',
    rating: 4.5,
    visits: 760000,
    featured: false,
  },
  {
    id: 'weilai-zhiku',
    name: '未来智库',
    url: 'https://www.weilai-edu.com',
    domain: 'weilai-edu.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20study%20brand%20named%20Future%20Thinktank%20with%20abstract%20lightbulb%20symbol%20in%20amber%20gold%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-weilai-zhiku&orientation=squarish',
    description: '升学备考资料与学习经验分享社区。',
    intro: '未来智库是一个升学备考与学习经验分享的社区型平台，聚合了各地真题、复习资料与学长学姐的经验帖。内容分类清晰、检索方便，适配备考冲刺与长期规划两类使用场景。',
    categoryId: 'edu',
    region: '江苏',
    scale: '中',
    tags: ['升学备考', '学习资料', '经验分享'],
    addedAt: '2026-06-24',
    rating: 4.4,
    visits: 520000,
    featured: false,
  },
  {
    id: 'xingzhe-wujiang',
    name: '行者无疆',
    url: 'https://www.xingzhewujiang.com',
    domain: 'xingzhewujiang.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20travel%20brand%20named%20Xingzhe%20Wujiang%20with%20abstract%20mountain%20path%20symbol%20in%20sky%20blue%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-xingzhe-wujiang&orientation=squarish',
    cover: 'https://readdy.ai/api/search-image?query=modern%20travel%20website%20hero%20banner%20with%20abstract%20mountain%20range%20and%20sky%20blue%20gradient%20scenery%20over%20misty%20horizon%2C%20clean%20minimal%20wanderlust%20style%2C%20no%20text&width=1200&height=675&seq=cover-xingzhe-wujiang&orientation=landscape',
    description: '自由行攻略与路线规划社区，记录真实旅行体验。',
    intro: '行者无疆是一个面向自由行爱好者的攻略与路线规划社区，汇聚海量真实游记、行程单与目的地清单。平台支持按主题和季节筛选路线，帮助用户快速制定个性化行程，少走弯路。',
    categoryId: 'travel',
    region: '云南',
    scale: '高',
    tags: ['旅行攻略', '自由行', '路线规划'],
    addedAt: '2026-09-22',
    rating: 4.8,
    visits: 1980000,
    featured: true,
  },
  {
    id: 'youyou-holiday',
    name: '悠游假期',
    url: 'https://www.youyouholiday.com',
    domain: 'youyouholiday.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20travel%20brand%20named%20Youyou%20Holiday%20with%20abstract%20sun%20and%20palm%20symbol%20in%20sky%20blue%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-youyou-holiday&orientation=squarish',
    description: '酒店与机票预订服务，主打度假套餐。',
    intro: '悠游假期是一个以酒店、机票预订与度假套餐为主的一站式出行服务平台，提供比价、点评与行程管理功能。平台与众多酒店及航司直连，价格透明、退改灵活，适合家庭与情侣度假出行。',
    categoryId: 'travel',
    region: '海南',
    scale: '高',
    tags: ['酒店预订', '机票', '度假套餐'],
    addedAt: '2026-08-14',
    rating: 4.6,
    visits: 1140000,
    featured: false,
  },
  {
    id: 'tuyu-map',
    name: '途遇地图',
    url: 'https://www.tuyumap.com',
    domain: 'tuyumap.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20map%20brand%20named%20Tuyu%20Map%20with%20abstract%20map%20pin%20symbol%20in%20sky%20blue%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-tuyu-map&orientation=squarish',
    description: '目的地地图工具，标注周边景点与交通动线。',
    intro: '途遇地图是一款专注出行场景的地图工具，支持目的地周边景点标注、交通动线规划与离线收藏。界面清爽、操作直观，帮助旅行者在陌生城市中快速定位并及时调整行程。',
    categoryId: 'travel',
    region: '四川',
    scale: '中',
    tags: ['地图', '导航', '目的地'],
    addedAt: '2026-07-18',
    rating: 4.5,
    visits: 680000,
    featured: false,
  },
  {
    id: 'linli-life',
    name: '邻里生活',
    url: 'https://www.linlilife.com',
    domain: 'linlilife.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20community%20brand%20named%20Linli%20Life%20with%20abstract%20house%20and%20heart%20symbol%20in%20rose%20pink%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-linli-life&orientation=squarish',
    description: '同城社区与便民服务信息聚合平台。',
    intro: '邻里生活是一个同城社区与便民服务信息聚合平台，提供社区公告、二手交易、拼单团购与邻里互助等板块。平台强调真实与本地化，帮助居民高效获取身边的服务与信息。',
    categoryId: 'life',
    region: '北京',
    scale: '高',
    tags: ['同城社区', '便民服务', '二手交易'],
    addedAt: '2026-09-06',
    rating: 4.5,
    visits: 1260000,
    featured: false,
  },
  {
    id: 'daojia-service',
    name: '到家服务',
    url: 'https://www.daojiafuwu.com',
    domain: 'daojiafuwu.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20home%20service%20brand%20named%20Daojia%20Service%20with%20abstract%20broom%20and%20sparkle%20symbol%20in%20rose%20pink%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-daojia-service&orientation=squarish',
    description: '家政保洁与上门维修的预约服务平台。',
    intro: '到家服务是一个提供家政保洁、家电维修、管道疏通等上门服务的预约平台。服务人员实名认证、价格公开透明，支持在线预约与进度跟踪，让家庭日常维护变得省心省力。',
    categoryId: 'life',
    region: '上海',
    scale: '高',
    tags: ['家政', '上门维修', '预约服务'],
    addedAt: '2026-08-20',
    rating: 4.4,
    visits: 890000,
    featured: false,
  },
  {
    id: 'bianjie-life',
    name: '便捷生活',
    url: 'https://www.bianjielife.com',
    domain: 'bianjielife.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20life%20service%20brand%20named%20Bianjie%20Life%20with%20abstract%20calendar%20check%20symbol%20in%20rose%20pink%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-bianjie-life&orientation=squarish',
    description: '水电缴费与政务办事的生活服务入口。',
    intro: '便捷生活是一个集成水电燃气缴费、政务办事与生活查询的便民入口平台，把散落在各处的日常事务集中到统一界面。操作路径清晰、到账及时，帮助用户节省线下排队的时间成本。',
    categoryId: 'life',
    region: '广东',
    scale: '中',
    tags: ['生活缴费', '政务办事', '便民查询'],
    addedAt: '2026-07-12',
    rating: 4.3,
    visits: 610000,
    featured: false,
  },
  {
    id: 'kangjian-online',
    name: '康健在线',
    url: 'https://www.kangjian.com',
    domain: 'kangjian.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20health%20brand%20named%20Kangjian%20Online%20with%20abstract%20heart%20pulse%20symbol%20in%20fresh%20green%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-kangjian-online&orientation=squarish',
    description: '在线健康咨询与医学科普平台。',
    intro: '康健在线是一个提供在线健康咨询与医学科普的平台，内容由执业医师审核，覆盖常见病、慢病管理与健康生活方式等话题。平台注重信息的科学性与可读性，帮助用户做出更明智的健康决策。',
    categoryId: 'health',
    region: '北京',
    scale: '高',
    tags: ['健康咨询', '医学科普', '慢病管理'],
    addedAt: '2026-09-09',
    rating: 4.7,
    visits: 1420000,
    featured: false,
  },
  {
    id: 'yiwen-yida',
    name: '医问医答',
    url: 'https://www.yiwen.com',
    domain: 'yiwen.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20medical%20brand%20named%20Yiwen%20Yida%20with%20abstract%20stethoscope%20symbol%20in%20fresh%20green%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-yiwen-yida&orientation=squarish',
    description: '医生问答与就医指引服务社区。',
    intro: '医问医答是一个医生问答与就医指引社区，用户可就症状、用药与体检报告提出问题，获得专业建议与就诊指引。平台提醒线上咨询不能替代面诊，引导用户理性就医、合理用药。',
    categoryId: 'health',
    region: '上海',
    scale: '高',
    tags: ['医生问答', '就医指引', '在线咨询'],
    addedAt: '2026-08-02',
    rating: 4.5,
    visits: 830000,
    featured: false,
  },
  {
    id: 'yangsheng-tang',
    name: '养生堂',
    url: 'https://www.yangshengtang.com',
    domain: 'yangshengtang.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20wellness%20brand%20named%20Yangsheng%20Tang%20with%20abstract%20leaf%20and%20water%20drop%20symbol%20in%20fresh%20green%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-yangsheng-tang&orientation=squarish',
    description: '中医养生与四季调理知识平台。',
    intro: '养生堂是一个以中医养生与四季调理为主题的健康知识平台，提供食疗、经络、作息与情志调养等实用内容。内容通俗易懂，强调循序渐进与因人而异，帮助用户在日常生活中建立健康习惯。',
    categoryId: 'health',
    region: '浙江',
    scale: '中',
    tags: ['中医养生', '四季调理', '食疗'],
    addedAt: '2026-06-28',
    rating: 4.4,
    visits: 470000,
    featured: false,
  },
  {
    id: 'wanneng-tools',
    name: '万能工具箱',
    url: 'https://www.wannengtools.com',
    domain: 'wannengtools.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20utility%20brand%20named%20Wanneng%20Toolbox%20with%20abstract%20toolbox%20symbol%20in%20slate%20indigo%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-wanneng-tools&orientation=squarish',
    description: '上百款在线效率工具集合，即开即用免安装。',
    intro: '万能工具箱汇集了上百款在线效率工具，覆盖文本处理、图片编辑、编码转换、单位换算与开发辅助等场景。全部工具即开即用、免安装免注册，是办公与开发过程中的实用助手。',
    categoryId: 'tools',
    region: '北京',
    scale: '高',
    tags: ['在线工具', '效率办公', '免安装'],
    addedAt: '2026-09-30',
    rating: 4.8,
    visits: 2120000,
    featured: false,
  },
  {
    id: 'jijian-convert',
    name: '极简转换',
    url: 'https://www.jijian-convert.com',
    domain: 'jijian-convert.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20utility%20brand%20named%20Jijian%20Convert%20with%20abstract%20arrows%20cycle%20symbol%20in%20slate%20indigo%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-jijian-convert&orientation=squarish',
    description: '文档与媒体格式转换工具，支持批量处理。',
    intro: '极简转换是一款专注文档与媒体格式转换的在线工具，支持PDF、Office、图片与音视频等常见格式互转，并提供批量处理与压缩功能。转换速度快、文件自动清理，注重用户隐私安全。',
    categoryId: 'tools',
    region: '广东',
    scale: '中',
    tags: ['格式转换', '批量处理', '文档工具'],
    addedAt: '2026-08-11',
    rating: 4.6,
    visits: 940000,
    featured: false,
  },
  {
    id: 'kuaijie-doc',
    name: '快解文档',
    url: 'https://www.kuaijie-doc.com',
    domain: 'kuaijie-doc.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20document%20brand%20named%20Kuaijie%20Doc%20with%20abstract%20document%20and%20bolt%20symbol%20in%20slate%20indigo%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-kuaijie-doc&orientation=squarish',
    description: '在线文档编辑与协作平台，支持多人实时协作。',
    intro: '快解文档是一个在线文档编辑与团队协作平台，支持富文本、表格、演示与多人实时协作，并兼容常见Office格式。历史版本可追溯、权限可精细配置，适合团队日常文档编写与项目管理。',
    categoryId: 'tools',
    region: '上海',
    scale: '中',
    tags: ['在线文档', '实时协作', '办公'],
    addedAt: '2026-07-06',
    rating: 4.5,
    visits: 580000,
    featured: false,
  },
  {
    id: 'qiuxian-ge',
    name: '求贤阁',
    url: 'https://www.qiuxiange.com',
    domain: 'qiuxiange.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20recruitment%20brand%20named%20Qiuxian%20Ge%20with%20abstract%20handshake%20symbol%20in%20navy%20blue%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-qiuxian-ge&orientation=squarish',
    description: '综合招聘平台，覆盖多行业岗位与人才库。',
    intro: '求贤阁是一个覆盖多行业的综合招聘平台，企业与求职者可在平台上高效匹配。平台提供岗位搜索、简历投递与企业直聊功能，职位信息经过审核，帮助求职者更快找到合适机会。',
    categoryId: 'jobs',
    region: '北京',
    scale: '高',
    tags: ['招聘', '求职', '岗位匹配'],
    addedAt: '2026-09-14',
    rating: 4.6,
    visits: 1340000,
    featured: false,
  },
  {
    id: 'bole-hui',
    name: '伯乐汇',
    url: 'https://www.bolehui.com',
    domain: 'bolehui.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20career%20brand%20named%20Bole%20Hui%20with%20abstract%20ladder%20step%20symbol%20in%20navy%20blue%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-bole-hui&orientation=squarish',
    description: '中高端人才服务与职场发展社区。',
    intro: '伯乐汇是一个面向中高端人才的专业服务平台，提供猎头对接、职业规划与薪资报告等内容。社区聚集了大量资深从业者与HR，讨论真实职场话题，帮助用户规划长期的职业发展路径。',
    categoryId: 'jobs',
    region: '上海',
    scale: '高',
    tags: ['猎头服务', '职业规划', '职场社区'],
    addedAt: '2026-08-16',
    rating: 4.5,
    visits: 970000,
    featured: false,
  },
  {
    id: 'zhitong-che',
    name: '职通车',
    url: 'https://www.zhitongche.com',
    domain: 'zhitongche.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20career%20brand%20named%20Zhitong%20Che%20with%20abstract%20road%20arrow%20symbol%20in%20navy%20blue%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-zhitong-che&orientation=squarish',
    description: '面向应届生的校招与实习信息平台。',
    intro: '职通车是一个专注校园招聘与实习机会的信息平台，聚合各大企业的校招时间表、宣讲会与实习岗位。平台提供简历指导与面试经验分享，帮助应届生顺利从校园过渡到职场。',
    categoryId: 'jobs',
    region: '深圳',
    scale: '中',
    tags: ['校园招聘', '实习', '应届生'],
    addedAt: '2026-07-24',
    rating: 4.4,
    visits: 660000,
    featured: false,
  },
  {
    id: 'guangying-world',
    name: '光影视界',
    url: 'https://www.guangyingshijie.com',
    domain: 'guangyingshijie.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20film%20brand%20named%20Guangying%20World%20with%20abstract%20film%20reel%20symbol%20in%20warm%20amber%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-guangying-world&orientation=squarish',
    description: '影视资讯、剧集推荐与影评社区。',
    intro: '光影视界是一个集影视资讯、剧集推荐与影评互动于一体的内容社区，提供新片前瞻、榜单推荐与深度影评。内容更新及时、观点多元，是影迷发现好片与交流讨论的聚集地。',
    categoryId: 'entertainment',
    region: '北京',
    scale: '高',
    tags: ['影视资讯', '剧集推荐', '影评'],
    addedAt: '2026-09-18',
    rating: 4.7,
    visits: 1820000,
    featured: false,
  },
  {
    id: 'yuedu-she',
    name: '悦读社',
    url: 'https://www.yuedushe.com',
    domain: 'yuedushe.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20reading%20brand%20named%20Yuedu%20She%20with%20abstract%20stacked%20books%20symbol%20in%20warm%20amber%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-yuedu-she&orientation=squarish',
    description: '阅读社区与书单推荐，记录你的读书笔记。',
    intro: '悦读社是一个以阅读社区与书单推荐为核心的内容平台，用户可以记录读书笔记、参与共读活动并发现他人书单。平台鼓励真诚分享与理性讨论，为爱读书的人营造安静的交流空间。',
    categoryId: 'entertainment',
    region: '上海',
    scale: '中',
    tags: ['阅读社区', '书单', '读书笔记'],
    addedAt: '2026-08-27',
    rating: 4.6,
    visits: 1020000,
    featured: false,
  },
  {
    id: 'chaowan-planet',
    name: '潮玩星球',
    url: 'https://www.chaowanplanet.com',
    domain: 'chaowanplanet.com',
    logo: 'https://readdy.ai/api/search-image?query=minimal%20flat%20app%20icon%20logo%20for%20a%20Chinese%20trend%20toy%20brand%20named%20Chaowan%20Planet%20with%20abstract%20planet%20and%20star%20symbol%20in%20warm%20amber%20tone%20on%20clean%20white%20background%20centered%20vector%20emblem%20crisp%20modern%20corporate%20style&width=240&height=240&seq=logo-chaowan-planet&orientation=squarish',
    description: '潮流文创与手办周边资讯社区。',
    intro: '潮玩星球是一个聚焦潮流文创与手办周边的资讯社区，提供新品发售日历、开箱测评与玩家交流板块。平台汇集了众多设计师品牌与收藏玩家，是潮玩爱好者了解圈子动态的入口。',
    categoryId: 'entertainment',
    region: '广东',
    scale: '中',
    tags: ['潮流文创', '手办周边', '玩家社区'],
    addedAt: '2026-07-28',
    rating: 4.5,
    visits: 730000,
    featured: false,
  },
];

export const hotTags: string[] = [
  '在线工具',
  '购物',
  '新闻',
  '科技',
  '旅行攻略',
  '理财',
  '在线课程',
  '健康咨询',
  '招聘',
  '影视资讯',
  '格式转换',
  '同城社区',
];